// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as App_Icon$DvmAdminFrontendFr from "../../../../common/components/icons/App_Icon.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../intl/Intl_Utils.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../context/user/User_Types_Utils.bs.js";
import * as App_Clickable_Element$DvmAdminFrontendFr from "../../../../common/components/button/App_Clickable_Element.bs.js";
import * as Order_Detail_Dealer_Edits_CustomerDiscount_Modal$DvmAdminFrontendFr from "./Order_Detail_Dealer_Edits_CustomerDiscount_Modal.bs.js";

function voActionsStatesEditable(order) {
  var reprStatesEditable = Belt_List.length(Belt_List.keep(Belt_List.keepMap(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                      return Belt_Option.getWithDefault(x.actionType, "") === "REPR";
                    })), (function (x) {
                  return x.resultActionStatus;
                })), (function (x) {
              if (x === /* PAID */4 || x === /* PREINVOICED */5) {
                return true;
              } else {
                return x === /* NOBONUS */3;
              }
            }))) === 0;
  var match = Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16);
  var nonfleetVOActionStatesEditable = !(match > 15 || match < 1) && match !== 11 ? Belt_List.length(Belt_List.keep(Belt_List.keepMap(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                        return Belt_Option.getWithDefault(x.actionWithUsedCar, false);
                      })), (function (x) {
                    return x.resultActionStatus;
                  })), (function (x) {
                if (x === /* PAID */4 || x === /* PREINVOICED */5) {
                  return true;
                } else {
                  return x === /* NOBONUS */3;
                }
              }))) === 0 : true;
  if (reprStatesEditable) {
    return nonfleetVOActionStatesEditable;
  } else {
    return false;
  }
}

function isCustomerDiscountEditable(order, selectedRole) {
  var match = Belt_Option.getWithDefault(order.body.resultDelivered, false);
  var match$1 = voActionsStatesEditable(order);
  if (match && match$1) {
    if (selectedRole === /* Dealer */7 || User_Types_Utils$DvmAdminFrontendFr.isAdminDealer(selectedRole)) {
      return true;
    } else {
      return User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole);
    }
  } else {
    return false;
  }
}

function Order_Detail_Dealer_Edits_CustomerDiscount(Props) {
  var orderId = Props.orderId;
  var order = Props.order;
  var reloadPage = Props.reloadPage;
  var lastCorrectionValues = Props.lastCorrectionValues;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = React.useState(function () {
        return null;
      });
  var setModal = match$1[1];
  var currentValue = Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerDiscount, (function (x) {
          return x.customerDiscount;
        }));
  var currentValueFormated = Belt_Option.getWithDefault(Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(lastCorrectionValues, order.body.orderCustomerDiscount, (function (x) {
                  return x.customerDiscount;
                })), undefined, (function (x) {
              if (x > 0.0) {
                return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
              }
              
            })), "-");
  return React.createElement(React.Fragment, undefined, isCustomerDiscountEditable(order, match[0].selectedRole) ? React.createElement(App_Clickable_Element$DvmAdminFrontendFr.make, {
                    onClick: (function (param) {
                        Curry._1(setModal, (function (param) {
                                return React.createElement(Order_Detail_Dealer_Edits_CustomerDiscount_Modal$DvmAdminFrontendFr.make, {
                                            onClose: (function (param) {
                                                Curry._1(setModal, (function (param) {
                                                        return null;
                                                      }));
                                              }),
                                            orderId: orderId,
                                            onOk: (function (param) {
                                                Curry._1(setModal, (function (param) {
                                                        Curry._1(reloadPage, undefined);
                                                        return null;
                                                      }));
                                              }),
                                            value: currentValue
                                          });
                              }));
                      }),
                    children: React.createElement(Core.Grid, {
                          children: null,
                          container: true,
                          spacing: 1
                        }, React.createElement(Core.Grid, {
                              children: currentValueFormated,
                              item: true
                            }), React.createElement(Core.Grid, {
                              children: React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                                    size: /* Regular */2,
                                    type_: /* Edit */60
                                  }),
                              item: true
                            }))
                  }) : currentValueFormated, match$1[0]);
}

var make = Order_Detail_Dealer_Edits_CustomerDiscount;

export {
  voActionsStatesEditable ,
  isCustomerDiscountEditable ,
  make ,
}
/* react Not a pure module */
